import api from '@/lib/axios';

import type { LanguagesResponse, StringBundleResponse } from '@/types/localization';

/** Fetch the full string bundle for a given language, merged with org overrides. */
export const getStringBundle = async (
  language: string,
  organizationId?: string,
): Promise<Record<string, string>> => {
  const params = new URLSearchParams({ language });
  if (organizationId) {
    params.set('organization_id', organizationId);
  }
  const response = await api.get<StringBundleResponse>(
    `/localization-service/v1/strings/bundle?${params.toString()}`,
  );
  return response.data.strings;
};

/** Fetch the list of available languages. */
export const getAvailableLanguages = async (): Promise<string[]> => {
  const response = await api.get<LanguagesResponse>('/localization-service/v1/languages');
  return response.data;
};
